import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../CSS/Navbar.css";
import logo from "../assets/logo.jpg";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img src={logo} alt="Website Logo" className="logo-img" />
          <span className="logo-text">AmphiGreen</span>
        </Link>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        ☰
      </div>

      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>
          <Link to="/" className="nav-link" onClick={closeMenu}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" className="nav-link" onClick={closeMenu}>
            About
          </Link>
        </li>
        <li>
          <Link to="/services" className="nav-link" onClick={closeMenu}>
            Services
          </Link>
        </li>
        <li>
          <Link to="/leadership" className="nav-link" onClick={closeMenu}>
            Leadership
          </Link>
        </li>
        <li>
          <Link to="/alliances" className="nav-link" onClick={closeMenu}>
            Alliances
          </Link>
        </li>
        <li>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>
            Contact
          </Link>
        </li>
      </ul>

    </nav>
  );
}

export default Navbar;
